import { EPermissoes } from '@/enums/ePermissoes';
import { PAINEIS_GABARITO, rotaDoPainel } from '@/views/dashboard/dynamic-dashboards/engine/paineis';

export default [
  {
    description: 'Dashboard',
    path: 'dashboard',
    name: 'mtvConcreto',
    component: () => import('@/views/utilidade/Index.vue'),
    meta: {
      utlTipoFornecimentoId: 1,
      opcoesTipoFornecimento: { 1: 'Concreto' },
      permissions: [EPermissoes.Relatorio]
    },
    goesToMenu: true
  },
  {
    // Painéis de gestão (executivo, concreteiras, desvio-padrão, timeline, atrasos e NCs): um item
    // só; o usuário escolhe o painel no menu lateral do gabarito, que abre numa aba nova.
    description: 'Painéis de gestão',
    path: 'paineis-gestao',
    name: 'paineisgestaoconcreto',
    redirect: '/paineis',
    meta: {
      utlTipoFornecimentoId: 1,
      permissions: [...new Set(PAINEIS_GABARITO.map(p => p.permissao))],
      novaAba: '/paineis'
    },
    goesToMenu: true
  },
  // Endereços antigos de cada painel no menu: abrem o painel no gabarito (fora do menu).
  ...PAINEIS_GABARITO.map(p => ({
    path: `painel-${p.id}`,
    name: `painel${p.id.replace(/-/g, '')}concreto`,
    redirect: rotaDoPainel(p.id),
    meta: {
      utlTipoFornecimentoId: 1,
      permissions: [p.permissao]
    }
  })),
  {
    description: 'Analítico: caminhões',
    path: 'relatorio-analitico',
    name: 'recebimentoitemanaliticoconcreto',
    component: () => import('@/views/dashboard/recebimento-item/Index.vue'),
    meta: {
      utlTipoFornecimentoId: 1,
      permissions: [EPermissoes.Relatorio],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Concretagens Consolidadas',
    path: 'recebimento-consolidado',
    name: 'recebimentoconsolidadoconcreto',
    component: () => import('@/views/dashboard/recebimento/Index.vue'),
    meta: { utlTipoFornecimentoId: 1, permissions: [EPermissoes.Relatorio], escopoObra: 'obra' },
    goesToMenu: true
  },
  {
    description: 'Ensaio Consolidado',
    path: 'ensaio-consolidado',
    name: 'ensaioconsolidadoanaliticoconcreto',
    component: () => import('@/views/dashboard/ensaio-consolidado/Index.vue'),
    meta: {
      utlTipoFornecimentoId: 1,
      permissions: [EPermissoes.Relatorio],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    path: '',
    name: 'concretorelatorios',
    description: 'Relatórios',
    component: () => import('@/views/utilidade/Relatorios.vue'),
    meta: {
      utlTipoFornecimentoId: 1,
      opcoesTipoFornecimento: { 1: 'Concreto' },
      permissions: [EPermissoes.Relatorio]
    },
    goesToMenu: true
  }
];
